export const HERTZ_YELLOW = "#ffcc00"
export const HERTZ_YELLOW_SECONDARY = "#fff2bf"
export const GREY = "#aaa"
export const GREY_SECONDARY = "#ddd"
export const BLUE = "#8ca3ff"
export const BLUE_SECONDARY = "#bfccff"
export const SUCCESS = "#43a047"
export const WARNING = "#ffa000"
export const ERROR = "#d32f2f"
